import fuzzysearch from 'fuzzysearch'
import { useState } from 'react'
import { DefaultPageLayout, HeadMetatags } from 'routes/components/Layout'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { IntegrationsSearch } from 'routes/Integrations/components/Search'
import { IntegrationsError } from 'routes/Integrations/components/Error'
import { IntegrationPageCommonWrapper } from '../components/IntegrationPageCommonWrapper'
import { IntegrationWrapper } from '../components/IntegrationWrapper'
import { IntegrationOperationsList } from './components/Operations/OperationsList'
import common from 'routes/Integrations/Integration/Integration.module.scss'

export default function IntegrationOperationsPage({
  integration,
}: {
  integration: IntegrationType
}) {
  if (!integration || !integration.key) {
    return <div>Loading...</div>
  }

  const [searchValue, setSearchValue] = useState('')
  const { operations = [] } = integration

  const onSearchChange = (value: string) => setSearchValue(value)

  const getVisibleOperations = () => {
    const normalizedSearch = searchValue.toLowerCase().trim()
    return operations.filter(({ name }) =>
      fuzzysearch(normalizedSearch, name.toLowerCase()),
    )
  }

  const filteredOperations = getVisibleOperations()
  const isFilteredOperations = filteredOperations?.length

  return (
    <DefaultPageLayout className={common.page}>
      <HeadMetatags
        title={`Operations - ${integration.name} Connector for Your Product`}
        description={`Add white-label customer-facing integration with ${integration.name} into your app with just a few lines of code.`}
        type={'article'}
        canonical={`/integrations/${encodeURIComponent(integration.key.toLowerCase())}`}
      />
      <IntegrationPageCommonWrapper integration={integration}>
        <IntegrationWrapper>
          <IntegrationsSearch
            value={searchValue}
            placeholder={'Search operations'}
            onChange={onSearchChange}
          />
          {isFilteredOperations ? (
            <IntegrationOperationsList
              integrationLink={integration.key as string}
              operations={filteredOperations}
            />
          ) : (
            <IntegrationsError searchValue={searchValue} isOperations />
          )}
        </IntegrationWrapper>
      </IntegrationPageCommonWrapper>
    </DefaultPageLayout>
  )
}
